import React from 'react';
import { flexRender, HeaderGroup } from '@tanstack/react-table';
import { DataNode } from '@/types';
import { resolveHeaderClassName } from './ReconciliationTable.utils';

interface TableHeaderRowProps {
  headerGroup: HeaderGroup<DataNode>;
}

/**
 * Component for rendering a single table header row
 */
export const TableHeaderRow: React.FC<TableHeaderRowProps> = ({ headerGroup }) => {
  return (
    <tr key={headerGroup.id} className="bg-gradient-to-r from-slate-50 to-gray-50 dark:from-gray-500 dark:to-gray-700">
      {headerGroup.headers.map((header) => (
        <th
          key={header.id}
          id={header.id}
          colSpan={header.colSpan}
          className={`border-b border-modern-light px-2 py-2 text-left font-semibold dark:bg-gray-700 dark:text-white text-slate-900 text-sm ${resolveHeaderClassName(
            header.id
          )}`}
        >
          {header.isPlaceholder ? null : (
            <div className="text-center whitespace-nowrap">
              {flexRender(header.column.columnDef.header, header.getContext())}
            </div>
          )}
        </th>
      ))}
    </tr>
  );
};
